<script setup lang="ts">
/* eslint-disable vue/no-v-html */
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';

defineProps<{
  content: string;
}>();
</script>

<template>
  <ContentContainer class="text-container">
    <ContentColumn>
      <div v-html="content" />
      <template v-if="$slots.notes?.({}).length" #right>
        <slot name="notes" />
      </template>
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
.text-container {
  margin-bottom: var(--spacing-m);

  :deep(.content-container) {
    *:last-child {
      margin-bottom: 0;
    }
  }

  :deep(a[href^=http]) {
    &::after {
      content: "";
      display: inline-block;
      width: 0.6em;
      height: 0.6em;
      margin-left: 0.4rem;
      background: url(@/icons/external-link.svg) no-repeat center;
      background-size: contain;
    }
  }
}
</style>
